import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../Layout';
import Login from '../Components/AuthComponent/SignInProcess/login';
import UserManagement from '../Components/AdminComponents/User Management/dashboard';
import Dashboard from '../Components/AdminComponents/Dashboard/Dashboard';
import Setting from '../Components/AdminComponents/Setting/setting';
import Support from '../Components/AdminComponents/Support/support';
import PrivateRoute from '../Utils/privateRoute';
import Buyer from '../Components/AdminComponents/Buyer/buyer';
import Sales from '../Components/AdminComponents/Sales/sales';
import Origin from '../Components/AdminComponents/Origin/origin';
import Shipping from '../Components/AdminComponents/ShippingMethod/shipping';
import Category from '../Components/AdminComponents/Category/category';
import Supplier from '../Components/AdminComponents/Supplier/supplier';
import Customer from '../Components/AdminComponents/Customer/customer';
import Arrival from '../Components/AdminComponents/Arrival/arrival';
import Product from '../Components/AdminComponents/Product/product';
import ProductGroup from '../Components/AdminComponents/ProductGroup/productGroup';
import Comingsoon from '../Components/AdminComponents/ComingSoon/comingsoon';
import Inout from '../Components/AdminComponents/inOut/inout';
import Inoutv2 from '../Components/AdminComponents/inOut/inoutv2';
import Reserve from '../Components/AdminComponents/Reserve/reserve';
import Inventory from '../Components/AdminComponents/DailyInventory/inventory';
import OrderArrivalMasterDate from '../Components/OrderArival/orderArrivalMasterDate';
import ForgotPassword from '../Components/AuthComponent/SignInProcess/forgotPassword';
import Profile from '../Components/AdminComponents/Profile/profile';
import AdminMember from '../Components/AdminComponents/Admin/admin';
import ResetPassword from '../Components/AuthComponent/SignInProcess/resetPassword';
import CustomerSubGroup from '../Components/AdminComponents/Customer/customerSubGroup';
import PrepackProduct from '../Components/AdminComponents/PrepackProduct/prepackProduct';
import PrepackInout from '../Components/AdminComponents/prepackInout/prepackInout';
export default function Routing() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<Login />} />

        {/* Protected Routes */}
        {/* <Route path="/admin" element={<PrivateRoute />}> */}
         <Route path="/admin" element={<Layout />}> 

          {/* <Route path="" element={<Layout />}> */}
            {/* <Route index element={<PrivateRoute component={UserManagement} />} /> */}
            <Route path="dashboard" element={<PrivateRoute component={Dashboard} />} />
            <Route path="setting" element={<PrivateRoute component={Setting} />} />
            <Route path="support" element={<PrivateRoute component={Support} />} />
            <Route path="profile" element={<PrivateRoute component={Profile} />} />
            <Route path="buyer" element={<PrivateRoute component={Buyer} />} />
            <Route path="sales" element={<PrivateRoute component={Sales} />} />
            <Route path="shipping-method" element={<PrivateRoute component={Shipping} />} />
            <Route path="category" element={<PrivateRoute component={Category} />} />
            <Route path="supplier" element={<PrivateRoute component={Supplier} />} />
            <Route path="customer" element={<PrivateRoute component={Customer} />} />
            <Route path="arrival" element={<PrivateRoute component={Arrival} />} />
            <Route path="origin" element={<PrivateRoute component={Origin} />} />
            <Route path="product" element={<PrivateRoute component={Product} />} />
            <Route path="prepack-product" element={<PrivateRoute component={PrepackProduct} />} />
            <Route path="product-group" element={<PrivateRoute component={ProductGroup} />} />
            <Route path="order-arrival-date" element={<PrivateRoute component={OrderArrivalMasterDate} />} />

            <Route path="user-management" element={<PrivateRoute component={UserManagement} />} />
            <Route path="coming" element={<PrivateRoute component={Comingsoon} />} />
            <Route path="reserve" element={<PrivateRoute component={Reserve} />} />
            <Route path="daily-inventory" element={<PrivateRoute component={Inventory} />} />
            <Route path="chat" element={<PrivateRoute component={Comingsoon} />} />
            <Route path="admin-member" element={<PrivateRoute component={AdminMember} />} />
            <Route path="customer-sub-group" element={<PrivateRoute component={CustomerSubGroup} />} />
            <Route path="inout" element={<PrivateRoute component={Inout} />} />
            <Route path="prepack-inout" element={<PrivateRoute component={PrepackInout} />} />
            <Route path="inout-old" element={<PrivateRoute component={Inoutv2} />} />
            {/* <Route index element={<PrivateRoute component={UserManagement} />} />
            <Route path="dashboard" element={<PrivateRoute component={Subscription} />} />
            <Route path="setting" element={<PrivateRoute component={Meditation} />} />
            <Route path="support" element={<PrivateRoute component={Support} />} />
            <Route path="buyer" element={<PrivateRoute component={Buyer} />} />
            <Route path="sales" element={<PrivateRoute component={Sales} />} />
            <Route path="shipping-method" element={<PrivateRoute component={Shipping} />} />
            <Route path="category" element={<PrivateRoute component={Category} />} />
            <Route path="supplier" element={<PrivateRoute component={Supplier} />} />
            <Route path="customer" element={<PrivateRoute component={Customer} />} />
            <Route path="arrival" element={<PrivateRoute component={Arrival} />} />
            <Route path="origin" element={<PrivateRoute component={Origin} />} />
            <Route path="product" element={<PrivateRoute component={Product} />} />
            <Route path="product-group" element={<PrivateRoute component={ProductGroup} />} />
            <Route path="user-management" element={<UserManagement />} />
            <Route path="coming" element={<Comingsoon />} /> */}

          {/* </Route> */}
        </Route>
      </Routes>
      <ToastContainer />
    </>
  );
}
